import React from 'react';
import QrCode from 'qrcode.react';
import styled from '@emotion/styled';

interface IBookingQrProps {
	reference: string;
	className?: string;
	size?: number;
}

export const BookingQr = ({ className, reference, size }: IBookingQrProps) => (
	<StyledBookingQr className={className}>
		<QrCode value={reference} size={size ?? 180} />
	</StyledBookingQr>
);

export const StyledBookingQr = styled.div``;
